module.exports = __webpack_public_path__ + "img/baa_gold.0cd07c03.png";